const config = window.plansConfig?.courseInfoBox ?? window.courseInfoBoxConfig;

export default config;